module.exports = __webpack_public_path__ + "img/fb.80b12638.png";